import {XIcon} from '@primer/octicons-react'
import {Flash, IconButton} from '@primer/react'
import type {ComponentProps, PropsWithChildren} from 'react'

interface Props {
  variant: ComponentProps<typeof Flash>['variant']
  onClose(): void
}

export function DismissibleFlash({variant, onClose, children}: PropsWithChildren<Props>) {
  return (
    <Flash
      sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', pl: 3, pr: 2, py: 2}}
      variant={variant}
    >
      {children}
      <IconButton
        variant="invisible"
        sx={{'>svg': {m: 0}}}
        icon={XIcon}
        onClick={onClose}
        aria-label="Dismiss message"
        size="small"
      />
    </Flash>
  )
}

try{ DismissibleFlash.displayName ||= 'DismissibleFlash' } catch {}